import request from '../utils/request'

// 用户登录
export function login(data) {
  return request({
    url: '/login_controller/login',
    method: 'post',
    data
  })
}

// 发送短信验证码
export function sendSmsCode(data) {
  // 之前打的是 /send-code，后端没有这个控制器，调用直接 404
  // （controller not exists:send-code）。现在改成后台真实的动作。
  return request({
    url: '/login_controller/sendCode',
    method: 'post',
    data
  })
}

// 用户退出登录
export function logout() {
  return request({
    url: '/login_controller/logout',
    method: 'post'
  })
}

// 获取用户信息
export function getUserInfo() {
  // 之前打的是 /user-info，后端没有这个控制器，调用就是 404
  return request({
    url: '/login_controller/getUserInfo',
    method: 'get'
  })
}

// 修改密码
export function changePassword(data) {
  return request({
    url: '/login_controller/changePassword',
    method: 'post',
    data
  })
}